import script from "./uploadModel.vue?vue&type=script&setup=true&lang=js"
export * from "./uploadModel.vue?vue&type=script&setup=true&lang=js"

import "./uploadModel.vue?vue&type=style&index=0&id=889e0e2a&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-889e0e2a"]])

export default __exports__